<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        fill-rule="evenodd"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <mask id="hide" maskUnits="userSpaceOnUse" x="0" y="2" width="24" height="21">
            <path
                d="M2.946 22.571l4.125-4.125c1.5.786 3.143 1.179 4.929 1.179a9.48 9.48 0 003.107-.536c1.036-.357 1.902-.732 2.598-1.125.697-.393 1.527-1.009 2.491-1.848.965-.84 1.625-1.437 1.983-1.795.277-.277.706-.728 1.287-1.351l.534-.577c-2.036-2.464-3.893-4.25-5.571-5.357l3.857-3.804L21.054 2l-4.125 4.179C15.286 5.357 13.643 4.946 12 4.946c-2.071 0-4.018.599-5.84 1.795C4.34 7.938 2.287 9.786 0 12.286c2.607 2.75 4.446 4.5 5.518 5.25l-3.804 3.803 1.232 1.232zm5.09-7.553c-.572-.857-.857-1.768-.857-2.732 0-1.322.473-2.465 1.42-3.429.946-.964 2.08-1.446 3.401-1.446 1.036 0 1.964.303 2.786.91L12.054 11a1.394 1.394 0 01-.054-.429c0-.392.143-.767.429-1.125H12c-.786 0-1.446.277-1.982.83-.536.554-.804 1.224-.804 2.01 0 .535.09.964.268 1.285l-1.446 1.447zM12 17.16a4.57 4.57 0 01-2.786-.911l1.5-1.446c.357.214.786.321 1.286.321.786 0 1.446-.277 1.982-.83.536-.554.804-1.224.804-2.01v-.374c-.357.25-.715.375-1.072.375-.178 0-.321-.018-.428-.054L15.964 9.5c.572.857.857 1.786.857 2.786 0 1.321-.473 2.464-1.42 3.428-.946.965-2.08 1.447-3.401 1.447z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#hide)">
            <path
                d="M2.946 22.571l4.125-4.125c1.5.786 3.143 1.179 4.929 1.179a9.48 9.48 0 003.107-.536c1.036-.357 1.902-.732 2.598-1.125.697-.393 1.527-1.009 2.491-1.848.965-.84 1.625-1.437 1.983-1.795.277-.277.706-.728 1.287-1.351l.534-.577c-2.036-2.464-3.893-4.25-5.571-5.357l3.857-3.804L21.054 2l-4.125 4.179C15.286 5.357 13.643 4.946 12 4.946c-2.071 0-4.018.599-5.84 1.795C4.34 7.938 2.287 9.786 0 12.286c2.607 2.75 4.446 4.5 5.518 5.25l-3.804 3.803 1.232 1.232zm5.09-7.553c-.572-.857-.857-1.768-.857-2.732 0-1.322.473-2.465 1.42-3.429.946-.964 2.08-1.446 3.401-1.446 1.036 0 1.964.303 2.786.91L12.054 11a1.394 1.394 0 01-.054-.429c0-.392.143-.767.429-1.125H12c-.786 0-1.446.277-1.982.83-.536.554-.804 1.224-.804 2.01 0 .535.09.964.268 1.285l-1.446 1.447zM12 17.16a4.57 4.57 0 01-2.786-.911l1.5-1.446c.357.214.786.321 1.286.321.786 0 1.446-.277 1.982-.83.536-.554.804-1.224.804-2.01v-.374c-.357.25-.715.375-1.072.375-.178 0-.321-.018-.428-.054L15.964 9.5c.572.857.857 1.786.857 2.786 0 1.321-.473 2.464-1.42 3.428-.946.965-2.08 1.447-3.401 1.447z"
            />
            <path d="M36.571-11.714H-12.19v48.762H36.57v-48.762z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'HideSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
